import { useSearchParams } from 'react-router-dom';

type UseWorkspaceTabsParams<T> = {
  defaultTab: T;
  tabParam?: string;
  resetParamsOnChange?: boolean;
};

const useWorkspaceTabs = <T extends string>({
  defaultTab,
  tabParam = 'tab',
  resetParamsOnChange = false,
}: UseWorkspaceTabsParams<T>) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tab = (searchParams.get(tabParam) as T) || defaultTab;

  const setTab = (next: T) => {
    const params = resetParamsOnChange
      ? new URLSearchParams()
      : new URLSearchParams(searchParams);
    params.set(tabParam, next);
    setSearchParams(params, { replace: true });
  };

  return { tab, setTab };
};

export default useWorkspaceTabs;
